import { render, staticRenderFns } from "./ParticipantRow.vue?vue&type=template&id=270cbdd4"
import script from "./ParticipantRow.vue?vue&type=script&lang=js"
export * from "./ParticipantRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports